module.exports = __webpack_public_path__ + "static/media/documents.9a90084d.svg";